var __jsx = React.createElement;
import React, { forwardRef, useRef, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";
import ContentBox from "@/pages/car-comparison/components/ContentBox";
import ContentItem from "@/pages/car-comparison/components/ContentItem";
import { CDN_LINK } from "@globalConfig";
import Accordion from "@componentsShared/Tailwind/Accordion/Accordion";
import useBoolean from "@hooks/useBoolean";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
var InspectionReport = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var details = _ref.details,
    title = _ref.title;
  var gallery = useBoolean(false);
  var _useState = useState([]),
    images = _useState[0],
    setImages = _useState[1];
  var thumbnailsRef = useRef(null);
  var captionsRef = useRef(null);
  var renderNote = function renderNote(index, notes, rowIndex) {
    var _notes$index, _notes$index2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, ((_notes$index = notes[index]) === null || _notes$index === void 0 ? void 0 : _notes$index.status) === true ? /*#__PURE__*/React.createElement("img", {
      id: "compare-inspection-pass-".concat(rowIndex, "-car-").concat(index + 1),
      className: "w-5 h-5",
      src: CDN_LINK + "/assets/images/check-payment.svg",
      alt: "check"
    }) : ((_notes$index2 = notes[index]) === null || _notes$index2 === void 0 ? void 0 : _notes$index2.status) === false ? /*#__PURE__*/React.createElement("img", {
      id: "compare-inspection-fail-".concat(rowIndex, "-car-").concat(index + 1),
      className: "w-5 h-5",
      src: CDN_LINK + "/assets/images/check-elimination.svg",
      alt: "check"
    }) : null);
  };
  var renderNoteTitle = function renderNoteTitle(index, values, mainTitle, rowIndex) {
    var _values$index, _values$index2, _values$index5;
    return /*#__PURE__*/React.createElement(React.Fragment, null, (_values$index = values[index]) !== null && _values$index !== void 0 && _values$index.status ? /*#__PURE__*/React.createElement("span", {
      id: "compare-inspection-note-text-".concat(rowIndex, "-car-").concat(index + 1),
      className: "text-gray-text text-sm font-semibold"
    }, (_values$index2 = values[index]) === null || _values$index2 === void 0 ? void 0 : _values$index2.title) : /*#__PURE__*/React.createElement("span", {
      id: "compare-text-link",
      onClick: function onClick() {
        var _values$index3, _values$index4;
        return handleViewNotes((_values$index3 = values[index]) === null || _values$index3 === void 0 ? void 0 : _values$index3.status, (_values$index4 = values[index]) === null || _values$index4 === void 0 ? void 0 : _values$index4.notes, mainTitle);
      },
      className: "text-primary text-sm font-semibold underline"
    }, (_values$index5 = values[index]) === null || _values$index5 === void 0 ? void 0 : _values$index5.title));
  };
  var handleViewNotes = function handleViewNotes(status, notes, noteTitle) {
    if (status || !notes || notes.length === 0) {
      return;
    }
    var mappedImages = notes === null || notes === void 0 ? void 0 : notes.map(function (note) {
      return {
        src: note === null || note === void 0 ? void 0 : note.image,
        title: noteTitle,
        description: note === null || note === void 0 ? void 0 : note.note,
        width: 740,
        height: 550
      };
    });
    setImages(mappedImages);
    gallery.setTrue();
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "compare-inspection-section",
    className: "md:max-w-[767px] md:m-auto md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3",
    ref: ref
  }, /*#__PURE__*/React.createElement("p", {
    id: "compare-inspection-title",
    className: "text-sm font-bold text-gray-text text-start"
  }, title), /*#__PURE__*/React.createElement(ContentBox, {
    id: "compare-inspection-box"
  }, details === null || details === void 0 ? void 0 : details.map(function (detail, index) {
    var hasNote;
    if (Array.isArray(detail === null || detail === void 0 ? void 0 : detail.values)) {
      var _detail$values;
      hasNote = detail === null || detail === void 0 ? void 0 : (_detail$values = detail.values) === null || _detail$values === void 0 ? void 0 : _detail$values.some(function (note) {
        return note.status === false;
      });
    } else {
      var _Object$values;
      hasNote = (_Object$values = Object.values(detail === null || detail === void 0 ? void 0 : detail.values)) === null || _Object$values === void 0 ? void 0 : _Object$values.some(function (note) {
        return note.status === false;
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, hasNote ? /*#__PURE__*/React.createElement("div", {
      id: "compare-inspection-row-".concat(index),
      className: "flex flex-col gap-2"
    }, /*#__PURE__*/React.createElement("p", {
      id: "compare-inspection-row-title-".concat(index),
      className: "text-gray-text text-sm font-bold md:hidden"
    }, title), /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(Accordion.Item, {
      background: "bg-gray-alice"
    }, /*#__PURE__*/React.createElement(Accordion.Title, null, /*#__PURE__*/React.createElement(ContentItem.Panel, {
      itemTitle: /*#__PURE__*/React.createElement("span", {
        className: "text-gray-text text-sm font-bold"
      }, detail === null || detail === void 0 ? void 0 : detail.title),
      rightNode: renderNote(0, detail === null || detail === void 0 ? void 0 : detail.values, index),
      leftNode: renderNote(1, detail === null || detail === void 0 ? void 0 : detail.values, index),
      titleInside: true,
      hasTitle: true,
      rightId: "compare-inspection-panel-right-".concat(index),
      leftId: "compare-inspection-panel-left-".concat(index)
    })), /*#__PURE__*/React.createElement(Accordion.Body, {
      className: "pt-0"
    }, /*#__PURE__*/React.createElement(ContentItem.Panel, {
      hasTitle: true,
      itemTitle: "",
      titleInside: true,
      hasSeparator: false,
      rightNode: renderNoteTitle(0, detail === null || detail === void 0 ? void 0 : detail.values, detail === null || detail === void 0 ? void 0 : detail.title, index),
      leftNode: renderNoteTitle(1, detail === null || detail === void 0 ? void 0 : detail.values, detail === null || detail === void 0 ? void 0 : detail.title, index),
      rightId: "compare-inspection-note-right-".concat(index),
      leftId: "compare-inspection-note-left-".concat(index)
    }))))) : /*#__PURE__*/React.createElement(ContentItem, {
      id: "compare-inspection-row-".concat(index),
      titleId: "compare-inspection-row-label-".concat(index),
      rightId: "compare-inspection-row-right-".concat(index),
      leftId: "compare-inspection-row-left-".concat(index),
      key: (detail === null || detail === void 0 ? void 0 : detail.title) + index,
      centerTitleDesktop: true,
      itemTitle: detail === null || detail === void 0 ? void 0 : detail.title,
      rightNode: renderNote(0, detail === null || detail === void 0 ? void 0 : detail.values, index),
      leftNode: renderNote(1, detail === null || detail === void 0 ? void 0 : detail.values, index),
      titleInside: true
    }));
  }), /*#__PURE__*/React.createElement(Lightbox, {
    carousel: {
      finite: true
    },
    open: gallery.value,
    thumbnails: {
      ref: thumbnailsRef
    },
    plugins: [Captions, Thumbnails, Counter],
    captions: {
      ref: captionsRef,
      descriptionTextAlign: "center"
    },
    close: function close() {
      return gallery.setFalse();
    },
    slides: images,
    styles: {
      root: {
        zIndex: 9999999999
      },
      captionsTitle: {
        lineHeight: '1.8'
      },
      captionsDescription: {
        lineHeight: '1.5'
      },
      thumbnailsContainer: {
        paddingBottom: "30px"
      }
    },
    counter: {
      container: {
        style: {
          top: '60px',
          left: '50%',
          transform: 'translateX(-50%)'
        }
      }
    }
  }))));
});
export default InspectionReport;